import { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";

import styles from "../assets/css/style.module.scss";
import logo from "../assets/img/abound_logo.svg";
import cart from "../assets/img/signupv2/willow/cart.svg";
import earn from "../assets/img/earn.svg";
import exchange from "../assets/img/signupv2/willow/exchange.svg";
import gaanaLogo from "../assets/img/gaanaplus.svg";
import TcQR from "../assets/img/tc_qr.png";
import appStore from "../assets/img/signupv2/willow/app-store.svg";
import googlePlay from "../assets/img/signupv2/willow/google-play.svg";
import gift from "../assets/img/signupv2/willow/gift.svg";
import wallet from "../assets/img/signupv2/willow/wallet.svg";

import {
  formatPhoneNumber,
  formatUsPhoneToString,
  validatePhone,
} from "../libs/utils";
import { sendMeLink } from "../services/auth";
import { verifyPasswordReset } from "../services/auth";
import { willow_cancel_downloaded, willow_signup_downloaded } from "../libs/events";

function WillowRightSection({ screen = 2, appLinkToken, id, flow }) {
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [linkSent, setLinkSent] = useState(false);

  const inputRef = useRef();

  const handlePhone = (e) => {
    const phone = formatPhoneNumber(e.target.value);
    setPhone(phone);
  };

  const handleClick = () => {
    setMessage("");
    if (validatePhone(phone) && appLinkToken) {
      sendMeLink({
        notification_method: "SMS",
        identifier: formatUsPhoneToString(phone),
        token: appLinkToken,
        user_identifier: id,
      })
        .then((response) => {
          if (response?.success) {
            setMessage(response.message);
            setPhone("");
            setLinkSent(true);
          }
        })
        .catch((error) => {
          inputRef.current.classList.add(styles.animateShake);
          setTimeout(() => {
            inputRef.current.classList.remove(styles.animateShake);
          }, 500);
          if (error?.response?.data?.error?.message == 0) {
            setError("Oops! Something went wrong");
          } else {
            setError(
              error?.response?.data?.error?.message
                ? error?.response?.data?.error?.message
                : error.message
            );
          }
        });
    } else {
      inputRef.current.querySelector("input").focus();
      inputRef.current.classList.add(styles.animateShake);
      setTimeout(() => {
        inputRef.current.classList.remove(styles.animateShake);
      }, 500);
    }
  };

  useEffect(() => {
    if (screen === 2) {
      verifyPasswordReset({
        id: id,
        token: appLinkToken,
        action_type: "SEND_APP_LINK",
      })
        .then((response) => {})
        .catch((error) => {
          if (error?.response?.data?.error?.message == 0) {
            setError("Oops! Something went wrong");
          } else {
            setError(
              error?.response?.data?.error?.message
                ? error?.response?.data?.error?.message
                : error.message
            );
          }
        });
    }
  }, [screen]);

  const handleDownload = (platform) => {
    if (platform === "ios") {
      if (flow === "CANCELLATION") {
        willow_cancel_downloaded({ platform_selected: "ios" });
      } else {
        willow_signup_downloaded({ platform_selected: "ios" });
      }

      window.open("https://abound.onelink.me/P9V6/2mm28blz");
    } else if (platform === "android") {
      if (flow === "CANCELLATION") {
        willow_cancel_downloaded({ platform_selected: "android" });
      } else {
        willow_signup_downloaded({ platform_selected: "android" });
      }

      window.open("https://abound.onelink.me/P9V6/2mm28blz");
    }
  };
  return (
    <>
      <div className={styles.logoGroup}>
        <div className={styles.logo}>
          <img src={logo} />
        </div>
      </div>
      {screen === 2 ? (
        <>
          <div className={styles.upperContainer}>
            <div className={styles.item}>
              <div className={styles.upperSection}>
                <img src={exchange} />
                <div className={styles.itemSubTitle}>Remittance</div>
              </div>
              <div className={styles.bottomSection}>
                Best FX rate with
                <br />
                zero fees
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.upperSection}>
                <img src={cart} />
                <div className={styles.itemSubTitle}>Grocery Stores</div>
              </div>
              <div className={styles.bottomSection}>
                5% Cashback on 4000+ Indian grocery stores
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.upperSection}>
                <img src={earn} />
                <div className={styles.itemSubTitle}>Exclusive Offers</div>
              </div>
              <div className={styles.bottomSection}>
                Offers on Wee, Disney+, Instacart etc
              </div>
            </div>
          </div>
          <div className={styles.text3}>
              A super app designed for NRIs
          </div>
          <div className={styles.smDivider}></div>
          <div className={styles.text4}>Get the Abound App</div>
          <div className={styles.text5}>
            We’ll send you a link through SMS to download the app.
          </div>
          <div className={styles.formContainer}>
            <div>
              <div className={styles.inputControl} ref={inputRef}>
                <div className={styles.numberPrefix}>+1</div>
                <input
                  value={phone}
                  onChange={handlePhone}
                  placeholder="Phone number"
                  className={styles.input}
                  disabled={linkSent}
                />
              </div>

              {/* <div>{message}</div> */}
              {(error || message) && (
                <div
                  className={styles[error ? "inputError" : "inputInfoSuccess"]}
                >
                  {error ? error : message}
                </div>
              )}
            </div>

            <Button
              type="submit"
              className={`${styles.btnGolden} ${styles.textBlack}`}
              onClick={handleClick}
              disabled={linkSent}
            >
              Send me App Link
            </Button>
          </div>
          <div className={styles.text6}>
            By requesting a link, you agree to receive a one-time automatic SMS
            message and certify that the number provided belongs to you.
          </div>
          <div className={styles.text7}>OR</div>
          <div className={styles.appLink}>
            <img src={TcQR} className={styles.tcQrLogo} />
            <div className={styles.appLinkRightSec}>
              <img src={appStore} onClick={()=>handleDownload("ios")}/>
              <img src={googlePlay} onClick={()=>handleDownload("android")}/>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={styles.itemContainer}>
            <div className={styles.item}>
              <img src={cart} />
              <div className={styles.itemBody}>
                <div className={styles.itemTitle}>Grocery Stores</div>
                <span>5% Cashback on 4000+ Indian grocery stores</span>
              </div>
            </div>
          </div>
          <div className={styles.itemContainer}>
            <div className={styles.item}>
              <img src={exchange} />
              <div className={styles.itemBody}>
                <div className={styles.itemTitle}>Send Money to India</div>
                <span>Best FX rate with zero fees</span>
              </div>
            </div>
          </div>
          
          <div className={styles.itemContainer}>
            <div className={styles.item}>
              <img src={gift} />
              <div className={styles.itemBody}>
                <div className={styles.itemTitle}>Rewards for NRIs</div>
                <span>Exclusive rewards & premium offers for Indians</span>
              </div>
            </div>
          </div>
          <div className={styles.itemContainer}>
            <div className={styles.item}>
              <img src={wallet} />
              <div className={styles.itemBody}>
                <div className={styles.itemTitle}>Automatic Cashback</div>
                <span>Shop and get cashback automatically</span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default WillowRightSection;
